import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' }
});

// Credit Packages
export const listPackages = (includeArchived = false) =>
  api.get('/admin/credit-packages', { params: { include_archived: includeArchived } });
export const createPackage = (data) => api.post('/admin/credit-packages', data);
export const updatePackage = (packageId, data) => api.put(`/admin/credit-packages/${packageId}`, data);
export const archivePackage = (packageId) => api.post(`/admin/credit-packages/${packageId}/archive`);

// User Credits & Premium
export const grantCredits = (userId, amount, reason) =>
  api.post(`/admin/users/${userId}/credits`, { amount, reason });
export const grantPremium = (userId, payload) =>
  api.post(`/admin/users/${userId}/premium`, payload);
export const revokePremium = (userId) => api.delete(`/admin/users/${userId}/premium`);
export const grantEntitlement = (userId, payload) =>
  api.post(`/admin/users/${userId}/entitlements`, payload);
export const revokeEntitlement = (userId, entitlementId) =>
  api.delete(`/admin/users/${userId}/entitlements/${entitlementId}`);
export const getUserDetail = (userId) => api.get(`/admin/users/${userId}/detail`);

// Promo Codes
export const listPromoCodes = () => api.get('/admin/promo-codes');
export const createPromoCode = (data) => api.post('/admin/promo-codes', data);
export const updatePromoCode = (code, data) => api.put(`/admin/promo-codes/${code}`, data);
export const deletePromoCode = (code) => api.delete(`/admin/promo-codes/${code}`);

// Promotions
export const listPromotions = () => api.get('/admin/promotions');
export const createPromotion = (data) => api.post('/admin/promotions', data);
export const updatePromotion = (id, data) => api.put(`/admin/promotions/${id}`, data);
export const deletePromotion = (id) => api.delete(`/admin/promotions/${id}`);

// Transactions & Audit
export const listTransactions = (params) => api.get('/admin/transactions', { params });
export const listAuditLog = (params) => api.get('/admin/audit-log', { params });

// Public promo validation
export const validatePromo = (code, packageId) =>
  api.post('/promo/validate', { code, package_id: packageId });

export default api;
